import React from 'react';
import PropTypes from 'prop-types';
import { BarChart as BarRecharts, Bar, XAxis, YAxis, Legend } from 'recharts';
import BarChartLabel from './BarChartLabel';
import { ViewerPrimaryColorUserStyle } from '../../../UserCustomization';

export const sum = (data, key) => data.reduce((acc, item) => acc + item[key], 0);

export const formatData = data => {
  const total1 = sum(data, 'value1');
  const total2 = sum(data, 'value2');

  return data.map(item => ({
    ...item,
    value1: item.value1 / total1,
    value2: item.value2 / total2,
  }));
};

const BarChart = ({ sectionTitle, colors, data, name1, name2 }) => {
  return (
    <div className="section-graph section-graph-100">
      <ViewerPrimaryColorUserStyle domStyle="color">
        <h4 className="section-title">{sectionTitle}</h4>
      </ViewerPrimaryColorUserStyle>

      <BarRecharts
        data={formatData(data)}
        width={700}
        height={200}
        margin={{ top: 30 }}
        barSize={20}
        barGap={0}
      >
        <XAxis
          dataKey="label"
          tickSize={0}
          tick={{ transform: 'translate(0, 15)' }}
        />

        <YAxis
          type="number"
          domain={[0, 0.5]}
          ticks={[0, 0.25, 0.5]}
          tickFormatter={value => `${value * 100}%`}
          tickSize={0}
          tick={{ transform: 'translate(-10, 0)' }}
        />

        <Legend verticalAlign="top" />

        <Bar
          dataKey="value1"
          fill={colors[0].toString()}
          name={name1}
          label={<BarChartLabel />}
        />
        <Bar
          dataKey="value2"
          fill={colors[4].toString()}
          name={name2}
          label={<BarChartLabel />}
        />
      </BarRecharts>
    </div>
  );
};

BarChart.propTypes = {
  sectionTitle: PropTypes.string.isRequired,
  colors: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.string]))
  .isRequired,
  name1: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name2: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  data: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value1: PropTypes.number,
    value2: PropTypes.number,
  })),
};

export default BarChart;



// WEBPACK FOOTER //
// ./src/components/Areas/AreaOverview/BarChart/BarChart.js